// only checks literal values (not objects)
export function allValuesAreTheSame<T>(values: Array<T>): boolean {
  if (values.length === 0) {
    return true;
  }

  const firstValue = values[0];
  return values.slice(1).every((value: T) => value === firstValue);
}
